// ############################ Require packages here ############################
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// ############################ Require files here ###############################

import './resources.scss';
import ScheduleForm from '../scheduleForm';
import RelatedResources from '../relatedResources';
import ShareUrl from './shareUrl';
import FactsheetModal from '../Industries/factsheetModal';


export default function Features1() {

    const navigate = useNavigate();
    return (
        <div className='seq-reports-view'>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <title>Not Optional - SEBI’s New Cybersecurity & Cyber Resilience Framework</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Everything Regulated Entities (REs) Need to Know About CSCRF—and How Sequretek Can Help" />
                <meta name="keywords" content="SEBI, CSCRF, Sequretek, Services, Cybersecrity services, Registered Entity, QRE, MRE, SRE" />
                <meta property="og:title" content="SEBI’s New Cybersecurity & Cyber Resilience Framework" />
                <meta property="og:description" content="Everything Regulated Entities (REs) Need to Know About CSCRF—and How Sequretek Can Help" />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='container contain-width mt-5'>
                <div className='breadcrumb pe-0 ps-0'>
                    <ul>
                        <li><span onClick={() => navigate('/resources-hub')}>Resources  </span>
                            <span onClick={() => navigate('/resources-hub', { state: { type: 'spotlight' } })}>{' > '} Spotlight</span>
                            <span>{' > '}Not Optional - SEBI’s New Cybersecurity & Cyber Resilience Framework</span>
                        </li>
                    </ul>



                </div>
                {/* section 2 DISCRIPTION */}
                <div className='seq-report-view'>
                    <div className='blog-div'>
                        <h3>Not Optional - SEBI’s New Cybersecurity & Cyber Resilience Framework</h3>
                        <div className='text-end'>
                            <button type="submit" onClick={() => {
                                window.location.href = "https://www.sequretek.com/resources/datasheet/Prepare%20for%202025%20-%20SEBIs%20New%20Cybersecurity%20and%20Cyber%20Resilience%20%20Framework%20for%20Registered%20Entities"
                            }} className='input-submit-btn btn btn-danger' >Datasheet</button>
                        </div>
                        <p>06-JAN-2025</p>
                        <div className='blog-body'>
                            <img src='/images/blog-images/SEBIspotlight.png' width={'100%'} height={420} alt='' />

                            <h4>What is SEBI CSCRF?</h4>
                            <p>The <strong>Cybersecurity and Cyber Resilience Framework (CSCRF)</strong> is SEBI’s latest and most comprehensive guideline aimed at strengthening the digital security posture of its Regulated Entities (REs). This updated framework, formalized in the <strong>SEBI Circular SEBI/HO/ITD-1/ITDCSCEXT/P/CIR/2024/113</strong> (August 20, 2024) and updated further via <strong>Circular SEBI/HO/ITD-1/ITDCSCEXT/P/CIR/2025/60</strong> (April 30, 2025), replaces all prior circulars, guidelines, and advisories related to cybersecurity.</p>
                            <p>The framework introduces mandatory controls, monitoring mechanisms, risk-based categorization, and governance policies that REs must now comply with to continue operations in the capital markets ecosystem.</p>

                            <h4>Compliance Timelines</h4>
                            <p>SEBI has defined staggered timelines to ensure regulated entities prepare for implementation:</p>
                            <ul>
                                <li><p><strong>January 1, 2025 - </strong>Mandatory for REs already covered under previous SEBI cybersecurity circulars.</p></li>
                                <li><p><strong>August 31, 2025 – </strong>Applicable for all Regulated Entities (REs), excluding MIIs, KRAs, and QRTAs.</p></li>
                            </ul>

                            <p>The category of an RE will be decided based on data from the previous financial year and will remain unchanged throughout the year, regardless of fluctuations. This category is validated during compliance submission.</p>
                            <p>“In case an RE is registered under more than one category… the highest applicable category shall prevail.”</p>

                            <h4>Key Requirements in CSCRF</h4>
                            <p>Some major updates under CSCRF include:</p>
                            <p><strong>Mandatory implementation of Hardware Security Module (HSM) </strong>for MIIs and Qualified REs</p>
                            <p><strong>Risk-based exemptions</strong> for mid-size, small-size, and self-certifying REs—subject to board-approved risk assessments</p>
                            <p><strong>Cloud adoption policies,</strong> aligned with SEBI’s March 2023 circular on secure cloud usage</p>

                            <h4>Simplify Compliance with Sequretek</h4>
                            <p>Navigating the complexities of CSCRF does not need to be daunting.</p>
                            <p>Sequretek’s AI-powered Percept platform supports end-to-end cybersecurity operations tailored to regulated entities. It enables you to scope your attack surface, discover vulnerabilities, monitor threats in real-time, automate incident response, manage identity access, and stay fully compliant with SEBI’s mandates—all on a single console.</p>

                            <h4>Percept Services Include:</h4>
                            <ul>
                                <li><p><strong>Security Operations & Management</strong></p></li>
                                <li><p><strong>Incident Response & Management</strong></p></li>
                                <li><p><strong>Patch Management as a Service</strong></p></li>
                                <li><p><strong>AI Security Assessment Services</strong></p></li>
                                <li><p><strong>Cyber Deception Platform Services</strong></p></li>
                                <li><p><strong>External Threat Surveillance Service</strong></p></li>
                            </ul>

                            <h4>Percept Solutions Powering Compliance:</h4>
                            <p><strong>Percept XDR & NG-SIEM:</strong></p>
                            <p>Real-time threat detection, AI-powered correlation, and automated response to reduce dwell time and ensure visibility across your IT environment.</p>

                            <p><strong>Percept Compliance Manager</strong></p>
                            <p>Streamlines SEBI-mandated audits with automated patching, risk dashboards, and governance workflows.</p>

                            <p><strong>Percept Identity</strong></p>
                            <p>Zero Trust access governance with role-based controls, identity lifecycle management, and compliance reporting.</p>

                            <p><strong>Percept EDR</strong></p>
                            <p>Advanced endpoint protection with real-time prevention, behavioral analysis, and rapid containment of threats.</p>

                            <h4>CERT-In Empaneled Certified Auditors</h4>
                            <p>Sequretek’s compliance methodology aligns with SEBI’s audit checklist. We are a CERT-In empaneled Information Security Auditor. We ensure your cyber audits meet regulatory expectations.</p>

                            <p><strong>Close Security Gaps</strong></p>
                            <p>Strengthen Compliance, Access Control, and Threat Response—All with Sequretek.</p>

                            <ul>
                                <li><p>Stay Audit-Ready</p></li>
                                <li><p>Detect, Respond & Remediate in Real-Time</p></li>
                                <li><p>Implement Zero Trust Access</p></li>
                            </ul>

                            <p>Take control of your SEBI CSCRF compliance.</p>

                            <h4>About Sequretek</h4>
                            <p>Sequretek is a global cybersecurity company that provides AI-powered, cloud-native, simple-to-use solutions with comprehensive visibility and threat management in a single console. Built on the Percept continuous threat exposure management framework, Sequretek’s products—Percept XDR & NG SIEM, Identity, EDR, and Compliance Manager—offer defense-in-depth and defense-in-breadth capabilities. Its AI technologies, processes, and expert teams ensure organizations’ IT assets are protected against cyberthreats while helping them comply with regulatory standards.</p>
                            <p>Know more:<a target='_blank' href='https://sequretek.com'>https://sequretek.com</a></p>

                        </div>
                    </div>
                </div>
                <ShareUrl
                    details={{ title: 'Not Optional—SEBI’s New Cybersecurity & Resilience Framework', url: 'https://www.sequretek.com/resources/features/Not-Optional-SEBI-New-Cybersecurity-&-Resilience-Framework ' }}
                />
                {/* section 3 RELATED RESOURCES */}
                <div className='seq-resources'>
                    <div className={window.innerWidth > 767 ? 'ps-0' : 'ps-3'}>
                        <h4>Related resources</h4>
                        <div className='row ms-0 me-0'>
                            <div className='col-md-12 ps-0'>
                                <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto ms-0'}>
                                    <RelatedResources
                                        page='resources'
                                        type='spotlight'
                                        title='Not Optional—SEBI’s New Cybersecurity & Resilience Framework'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section 4 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container '>
                    <div className="insurance-partseven">
                        <ScheduleForm
                            bg={'/images/bg-img22.svg'}
                            mobilebg={'/images/bg-img23.png'}
                            page='resources'
                            text={`Don't wait until it's too late. Strengthen your cyber defences today with Sequretek. Contact us to schedule a demo and learn how our cybersecurity solutions can arm your enterprise against evolving threats.`}
                        />
                    </div>
                </div>
            </div>



        </div>
    )
}
